"use client";
import SharedLabel, { type LabelProps } from "shared-web/components/form/Label/Label";
import { useFormControl } from "src/components/form/FormControl/FormControlContext";

export type { LabelProps } from "shared-web/components/form/Label/Label";
export default function Label(props: LabelProps) {
  const formControl = useFormControl();
  const control = !props.as || props.as === "label" ? formControl : undefined;
  return (
    <SharedLabel
      {...props}
      disabled={control?.disabled || props.disabled}
      required={props.required ?? control?.required}
      htmlFor={props.htmlFor ?? control?.id}
      data-invalid={control?.displayInvalid ? "true" : undefined}
    >
      {props.children ?? control?.label}
    </SharedLabel>
  );
}
